export default __webpack_public_path__ + "static/media/OTTO Motors.b2e73aaa.png";